import { useEffect } from 'react';

import { selectLargeType, setLargeType } from '../store/slices/uiSlice';
import { useAppDispatch, useAppSelector } from '../store/store';

/**
 * Hook that manages large type preference:
 * - Syncs localStorage with Redux state
 * - Applies CSS font size change to root element
 */
export function useLargeType() {
    const dispatch = useAppDispatch();
    const largeType = useAppSelector(selectLargeType);

    // Initialize from localStorage on mount
    useEffect(() => {
        const storedLargeType = localStorage.getItem('largeType');
        if (storedLargeType !== null) {
            const isEnabled = storedLargeType === 'true';
            dispatch(setLargeType(isEnabled));
        }
    }, [dispatch]);

    // Apply font size change
    useEffect(() => {
        const rootElement = document.documentElement;
        if (largeType) {
            rootElement.style.fontSize = '120%';
        } else {
            rootElement.style.fontSize = '';
        }
    }, [largeType]);

    return largeType;
}
